import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { isLiteOnlyLocation, isPageAllowed } from "@/common/utils/geoRules";
import { useScrollStore } from "@/common/store/scrollStore";
import { useAgeVerificationStore } from "@/common/store/ageVerificationStore";
import { popupBus } from "@/common/buses";

export const useCensor = () => {
  const [censorOff, setCensorOff] = useState<boolean>(false);
  const { pathname } = useLocation();

  const location = useGeolocationStore((state) => state.location);
  const appElement = useScrollStore((state) => state.scrollElement);
  const ageVerified = useAgeVerificationStore((state) => state.ageVerified);

  useEffect(() => {
    appElement?.classList.add("censored");

    const disableCensor = isPageAllowed(pathname, location)
      || (ageVerified && !isLiteOnlyLocation(location))
      || censorOff;

    if (disableCensor) {
      appElement?.classList.remove("censored");
    }
  }, [appElement, pathname, location, censorOff, ageVerified]);

  useEffect(() => {
    popupBus.on("opened", (event) => {
      setCensorOff(true);
    });
  }, []);
};
